// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"85":"mobile","588":"pc","860":"mobileHome","953":"pcHome"}[chunkId] + "." + {"85":"7c3643ca","588":"78703024","860":"54aeb11e","953":"5804c8bf"}[chunkId] + ".css";
};